var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translate } from "../../I18N";
import { advancedSort } from "../../utils/advancedSort";
import { NeedAuthorization } from "../../Auth";
import Attachment from "./Attachment";

import UploadSupportingFile from "./UploadSupportingFile";

class AttachmentsList extends Component {
  static arrangeFiles(files = []) {
    return advancedSort(files, { property: 'originalname' });
  }

  render() {
    const label = /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Supporting files")
    );


    const { parentId, parentSharedId, readOnly, storeKey, entity } = this.props;
    const forcedReadOnly = readOnly || Boolean(this.props.isTargetDoc);

    let uploadAttachmentButton = null;

    if (!forcedReadOnly) {
      uploadAttachmentButton = /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0, /*#__PURE__*/
      _jsx("div", { className: "attachment-add" }, void 0, /*#__PURE__*/
      _jsx(UploadSupportingFile, { entitySharedId: this.props.parentSharedId, storeKey: storeKey })
      )
      );

    }

    const attachments = AttachmentsList.arrangeFiles(this.props.attachments);
    return /*#__PURE__*/(
      _jsx("div", { className: "attachments-list-parent" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "attachments-list-header" }, void 0,
      attachments.length === 0 ? /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0,
      label
      ) : /*#__PURE__*/

      React.createElement(React.Fragment, null, label),

      uploadAttachmentButton
      ), /*#__PURE__*/
      _jsx("div", { className: "attachments-list" }, void 0,
      attachments.map((file, index) => /*#__PURE__*/
      _jsx(Attachment, {

        file: file,
        parentId: parentId,
        readOnly: forcedReadOnly,
        storeKey: storeKey,
        parentSharedId: parentSharedId,
        isSourceDocument: false,
        entity: entity }, index
      )
      )
      )
      ));

  }
}

AttachmentsList.defaultProps = {
  attachments: [],
  readOnly: false,
  isTargetDoc: false,
  parentId: null,
  parentSharedId: null,
  storeKey: '',
  entity: null
};











AttachmentsList.contextTypes = {
  confirm: PropTypes.func
};

export default AttachmentsList;